var Smartpage = {};
Smartpage.binding = {
    "bindings": [{ "key": "exampleKey", "selector": "exampleSelector", "event": "exampleEvent", "execute": function () { } }],
    "bind": function (key) {
        for (var i = 0; i < Smartpage.binding.bindings.length; i++) {
            if (key == Smartpage.binding.bindings[i]["key"]) {
                var selector = Smartpage.binding.bindings[i]["selector"];
                var event = Smartpage.binding.bindings[i]["event"];
                var execute = Smartpage.binding[i]["execute"];
                $(selector).on(event, execute);
            }
        }
    }
};


var openIdx = "";
var navBtns = ["#langDropdown", ".js-cartmini-icon", ".header-icon-search", ".js-userdropdown-toggle", ".js-navigation-toggle", "#mobile-filter-toggle"];
var navPopups = ["#langDrop", ".js-cartmini", ".js-content-large", ".js-userdropdown", ".js-navigation-mobile", ".js-productlist-filters-container"];



var fopen = false;
var filter_clone = ""; //always non mobile
var filter_clone_mobile = "";


function MobileFiltersOpened() {
    fopen = true;
    filterResult = "";
    $(openFacets.join(",")).addClass("active");
    filter_clone = $(".js-productlist-filters-container").clone();

    if (filter_clone_mobile == "") {
        filter_clone_mobile = filter_clone.clone();
    }
    $("body").addClass("overflow-hidden");
   
    $(".js-productlist-filters-container").replaceWith(filter_clone_mobile);
    $(".js-productlist-filters-container").show();
    $("body").trigger("eCom:PageChanged");
}


function MobileFiltersClosed() {
    fopen = false;
    filter_clone_mobile = $(".js-productlist-filters-container").clone();
    $(".js-productlist-filters-container").replaceWith(filter_clone);
    $(".js-productlist-filters-container").hide();
    $("body").removeClass("overflow-hidden");
    $("body").trigger("eCom:PageChanged");
}

$(document).ready(function () {

    $(document).on("click", ".navbar-mega .js-toggle-navigation-left a[href]", function (event) {
        var element = $(event.currentTarget),
            elementContainer = element.closest(".js-toggle-navigation-container"),
            elementLeft = elementContainer.find(".js-toggle-navigation-left"),
            elementContent = elementContainer.find(".js-toggle-navigation-content");

        elementContainer.addClass("open");

        elementLeft.find("a").removeClass("active");
        element.addClass("active");

        elementContent.find(".dropdown-menu-block").removeClass("open");
        elementContent.find(element.attr("href")).addClass("open");

        event.preventDefault();
        return false;
    });

    $(".navbar-mega .dropdown").on('show.bs.dropdown', function () {
        $(".page > .content").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#000', opacity: 0.7, cursor: 'auto' }, message: '' });
    });

    $(".navbar-mega .dropdown").on('hide.bs.dropdown', function () {
        $(".page > .content").unblock();
    });

    $(window).on("resize", function (e) {
        var mobileFilterOpen = $("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible");
        if (mobileFilterOpen) { //filters just openend due to resize
            if(!fopen) MobileFiltersOpened();
        } else {
            if(fopen){
                MobileFiltersClosed();
            }
        }
    });

    $(".search-form").on("submit", function (e) {
        if ($(".tt-input", $(e.target)).val().trim() == "") e.preventDefault();
    });

    if ($(".js-userdropdown").is(":visible")) {
        $(".js-userdropdown-toggle").toggleClass("active is-active");
        openIdx = navPopups.indexOf(".js-userdropdown");
    }

    function closeAllNavPopups(exclude) {
        var ar = [];
        var btns = [];
        for (var i = 0; i < navPopups.length; i++) {
            if (navPopups[i] != exclude) {
                ar.push(navPopups[i]);
                btns.push(navBtns[i]);
            }
        }
        $(ar.join(",")).hide();
        $(btns.join(",")).removeClass("active is-active");
       // if (fopen && !$(".js-productlist-filters-container").is(":visible")) MobileFiltersClosed();
    }

    $(document).on("click", function (e) {
        var mobileFilterOpen = $("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible");
        if (openIdx == 2 && !$.contains($(".search-form")[0], e.target)) {
            closeAllNavPopups();
            $("body").removeClass("overflow-hidden");
        }else{
            var f = false;
            for (var i = 0; i < navPopups.length; i++) {
                if ($(navPopups[i]).length == 0) continue;
                if ($(e.target).is(navPopups[i]) || ($(navPopups[i]).length > 0 && $.contains( $(navPopups[i])[0], e.target)) ) {
                    f = true;
                    break;
                }
            }
            if(f){
                if (openIdx != i) {
                    closeAllNavPopups();
                    $("body").removeClass("overflow-hidden");
                }
            } else {
                openIdx = "";
                closeAllNavPopups();
                $("body").removeClass("overflow-hidden");
            }
        }
        if (mobileFilterOpen != ($("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible"))) {
            if (mobileFilterOpen) MobileFiltersClosed();
            else MobileFiltersOpened();
        }
    });

    //js-toggle
    $(document).on("click", ".js-toggle", function (e) {
        console.log("now");
        var mobileFilterOpen = $("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible");
        var $btn = $(e.currentTarget);
        var target = $btn.attr("data-target");

        var elementBtnData = $btn.data(),
            elementBtnToogleType = elementBtnData.toggleType || "",
            elementBody = $btn.closest("body");

        if (elementBtnToogleType == "hamburger") {
            elementBody.removeClass("overflow-hidden");
        }

        $(target).toggle();
        $btn.toggleClass("active is-active");

        if ($(target).is(":visible")) {
            
            openIdx = navPopups.indexOf(target);
            closeAllNavPopups(target);

            if (elementBtnToogleType == "hamburger") {
                elementBody.addClass("overflow-hidden");
            }

        } else {
            
            openIdx = "";
            closeAllNavPopups();
            elementBody.removeClass("overflow-hidden");
        }
        if (mobileFilterOpen != ($("#mobile-filter-toggle").is(":visible") && $(".js-productlist-filters-container").is(":visible"))) {
            if (mobileFilterOpen) MobileFiltersClosed();
            else MobileFiltersOpened();
        }

        e.stopPropagation();
    });


    //js-change
    $(document).on("change", ".js-change", function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr("data-target");

        //console.log("clicked");
        e.stopPropagation();
        $(target).toggle();
    });

    //js-toggle-hover
    $(document).on("mouseenter", ".js-toggle-hover", function (e) {
        var $this = $(e.currentTarget);
        var target = $this.attr("data-target");
        e.stopPropagation();
        $(target).toggle();
    });

    /*
    $(".js-navigation-toggle").on("click", function (e) {
        var hamburger = $(this);
        var navigation = $(".js-navigation-mobile");

        //e.preventDefault();
        if (!navigation.is(":visible")) {
            navigation.show();
            hamburger.addClass("is-active");
        } else {
            navigation.hide();
            hamburger.removeClass("is-active");
        }
    });*/

    //validate fields
    $(document).on("click", ".js-validate-form", function (e) {
        e.preventDefault();
        var form = $(this).closest("form");

        if (validateFields($(form))) {
            form.submit();
        }
        return false;
    });

    $(document).on("click", ".js-next-step", function (e) {
        if (!validateFields($(this).closest("form"))) {
            e.preventDefault();
            return false;
        }
        return true;
    });

    $(document).on("change", ".js-req-toggle", function (e) {
        var element = $(e.currentTarget),
            elementData = element.data(),
            elementTarget = $(elementData.reqTarget);

        if (element.val()) {
            elementTarget.addClass("js-req");
        }
        else {
            elementTarget.removeClass("js-req");
        }
    });

    

    
    //newsletter
    $(".newsletter-signup-form").on("submit", function (e) {
        e.preventDefault();
        $form = $(e.target);
        $(".newsletter-busy", $form).show(); //show spinner
        $("button .lbl", $form).addClass("display-none");
        $(".newsletter-response-container", $form).addClass("display-none"); //hide last resp
        $(".newsletter-fail", $form).addClass("display-none"); //hide fail
        $.post($form.attr("action"), $form.serialize())
            .always(function () {
                $(".newsletter-busy", $form).hide();
                $(".newsletter-response-container", $form).removeClass("display-none").html("");
                $("button .lbl", $form).removeClass("display-none");
            })
            .done(function (data, textStatus, jqXHR) {
                if (textStatus == "success") {
                    $(".newsletter-response-container", $form).empty().append(data);
                }else jqXHR.reject(); //reject the promise and trigger fail callback
            })
            .fail(function () {
                $(".newsletter-fail", $form).removeClass("display-none");
            }) 
    });






//prod page favorite lists
    function configureFavModal(){

        $(".add-remove-fav").on("click", function (e) {
            $("#favorites .modal-body").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });
            $.get(e.target.href)
                .always(function () {
                    $("#favorites .modal-body").unblock();
                })
                .done(function (data, textStatus, jqXHR) {
                    if (textStatus == "success") {
                        $("#favorites .modal-body").replaceWith($("#favorites .modal-body", data));
                        configureFavModal();
                    } else jqXHR.reject();
                })
                .fail(function () {

                });
            return false;
        });

        //add to new list
        $("#addtolist").on("submit", function (e) {
            e.preventDefault();
            $form = $(e.target);
            $("#favorites .modal-body").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });
            $.post($form.attr("action"), $form.serialize())
                .always(function () {
                    $("#favorites .modal-body").unblock();
                })
                .done(function (data, textStatus, jqXHR) {
                    if (textStatus == "success") {
                        $("#favorites .modal-body").replaceWith($("#favorites .modal-body", data));
                        configureFavModal();
                    } else jqXHR.reject();
                })
                .fail(function () {

                });
        });

    }

    configureFavModal();


    function configureFavList() {

        $(".js-delete-favoritelist").on("click", function(e) {
            $(".js-delete-favoritelist-confirm").attr("href", $(this).attr("data-delete-link"));
        });
        $(".js-remove-from-fav").on("click", function (e) {
            
            $(".favorites").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });
            $.get($(this).attr("href"))
                .always(function () {
                    $(".favorites").unblock();
                })
                .done(function (data, textStatus, jqXHR) {
                    if (textStatus == "success") {
                        //console.log($(".favorites", data))
                        $(".favorites").replaceWith($(".favorites", data));
                        configureFavList();
                        $("input.js-ecom-product-quantity").focus(function () { $(this).select(); });
                        setupIncDec();
                    } else jqXHR.reject();
                })
                .fail(function () {

                })
            return false;
        });

        //$(".js-basket-add").on("submit", function (e) {
        //    console.log("add");
        //    e.preventDefault();
        //    $form = $(e.target);
        //    $(".favorites").block({ css: { border: 'none' }, overlayCSS: { backgroundColor: '#fff' }, message: '<i class="fa fa-spinner fa-spin"></i>' });
        //    $.post($form.attr("action"), $form.serialize())
        //        .always(function () {
        //            $(".favorites").unblock();
        //        })
        //        .done(function (data, textStatus, jqXHR) {
        //            if (textStatus == "success") {
        //                $(".favorites").replaceWith($(".favorites", data));
        //                $(".cart-mini").replaceWith($(".cart-mini", data));
        //                configureFavList();
        //            } else jqXHR.reject();
        //        })
        //        .fail(function () {

        //        })
        //});
        
    }

    configureFavList();

    tabs();

});

function tabs() {
    /* tabs */
    $(".js-tab-content").hide();
    $(".js-tab-content:first").show();

    /* if in tab mode */
    $("ul.tabs li").click(function () {

        $(".tab-content").hide();
        var activeTab = $(this).attr("rel");
        $("#" + activeTab).show();

        $("ul.tabs li").removeClass("active");
        $(this).addClass("active");

        //$(".tab-accordion-heading").removeClass("tab-accordion-active");
        //$(".tab-accordion-heading[rel^='" + activeTab + "']").addClass("tab-accordion-active");

    });

    /* accordion */
    $(".tab-accordion-heading").click(function () {

        var d_activeTab = $(this).attr("rel");
        var target = $("#" + d_activeTab);
        //if accordion is open
        /* 20170618 AE: Removed
        if (target.is(":visible")) {
            return false;
        }

        $(".tab-content").hide();

        target.slideDown();
        */

        target.slideToggle();


        //$(".tab-accordion-heading").removeClass("tab-accordion-active");
        //$(this).addClass("tab-accordion-active");

        $("ul.tabs li").removeClass("active");
        $("ul.tabs li[rel^='" + d_activeTab + "']").addClass("active");
    });
}

// FROM CUSTOM JS
// Place Custom Scripts here
$(".js-frontpage-slider").slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: false,
    focusOnSelect: true,
    arrows: true,
    prevArrow: $('.js-slick-prev'),
    nextArrow: $('.js-slick-next'),
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                arrows: false,
            }
        }
    ]

});

var openFacets = [];

var configureFacets = function () {
    $(".js-facet-view").click(function () {
        $(this).parent(".js-foldable-section").find(".js-facet-container").removeClass("display-none");
        $(this).parent(".js-foldable-section").find(".js-facet-view-text").addClass("display-none");
    });

    /* MOBILE FILTER ON CLICK */
    $('.js-foldable-filters').on('click', function (e) {
       // if ($(window).width() < 767) {
            $filter = $(this).closest(".js-foldable-section");
            if ($filter.hasClass('active')) {
                $filter.removeClass('active');
                openFacets = openFacets.filter(function (i) {
                    return i != "#" + $filter[0].id;
                });
            }
            else {
                $filter.addClass('active');
                openFacets.push("#" + $filter[0].id);
            }
        //}
    });

    $(".js-close-filter").on("click", function () {
        $(".js-filter-fw").hide();
        MobileFiltersClosed();
        filter_clone_mobile = "";
    });



    $(".js-get-filter-results").on("click", function () {

        //$(".js-productlist-filters-container").hide();
        if (filterResult != "") {
            var responseHTML = $(filterResult).find(".js-ecom-page-container").html();
            $(".js-ecom-page-container").html(responseHTML);
            if (eCommerce) {
                eCommerce.Overlay.hide();
            }
            fopen = false;
            //bind addtobasket after ajax
            addBasketEventListener($(".js-ecom-product-form"));
            $("body").trigger("eCom:PageChanged");
        } else {
            $(".js-productlist-filters-container").hide();
            MobileFiltersClosed();
        }
        //var currentState = null | history.state;
        //History.pushState(currentState, document.title, filterState); // logs {}, '', "?state=4"


    });

    $(".reset_filter").on("click", function () {
        //$(":input", "form.js-form-filters").not(':button, :submit, :reset, :hidden').val('').removeAttr('checked').removeAttr('selected');
        $('.js-select-filter-option').removeAttr('checked');
        eCommerce.Filters.submit();
    });

    $('.img-arrow.next-photo').click(function () {
        $('.slick-slider').slick('slickNext');
    });
    $('.img-arrow.prev-photo').click(function () {
        $('.slick-slider').slick('slickPrev');
    });

    // REMOVE CHECK FROM FACETS
    $('.js-remove-facet').on('click', function () {
        var facetId = $(this).attr('data-target');
        $('#' + facetId).prop("checked", false);
        eCommerce.Filters.submit();
    });

    setupIncDec();
}

$(document).ready(function () {
    configureFacets();
});

$("body").on("eCom:PageChanged", configureFacets);
/*
$('.header-content').on('click', function () {
    if ($(window).width() < 767) {
        if ($('.product-filters').is(':visible')) {
            $('.product-filters').hide();
        }
    }
});

*/